import { Box } from "@mui/material";
import Popover from "@mui/material/Popover";
import { forwardRef, useContext } from "react";
import { TagMetaData } from "src/config/store/services/media-api/types";
import { useGlobalEvent } from "src/modules/shared/hooks/use-global-event";
import { usePopover } from "src/modules/shared/hooks/use-popover/use-popover";
import { TagIcon } from "../../tag-icon/tag-icon";
import { PlayerContext } from "../media-player";
import TagPopup from "../tag-popup/tag-popup";
import { classes } from "./video-tag.styles";
import { TAG_COLORS } from "src/config/store/services/tags-api/types";

type TagProps = {
  tag: Required<TagMetaData>;
};

export type TagStyles = {
  top: string;
  left: string;
  display: string;
  width: string;
  height: string;
};

const actionKeys = ["Space", "ArrowRight", "ArrowLeft"];

export const baseTagSize = 88;

const VideoTag = forwardRef(({ tag }: TagProps, ref) => {
  const { wrapperRef, isPlaying, setIsPlaying } = useContext(PlayerContext);
  const { anchorEl, open, close, isOpen } = usePopover();

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (isPlaying) {
      setIsPlaying(false);
    }
    open(event);
  };

  const closeOnPlay = (e: KeyboardEvent) => {
    if (isOpen && actionKeys.includes(e.code)) {
      close();
    }
  };

  // close popup when video is played by space press
  useGlobalEvent(closeOnPlay, "keyup");

  // const animation = useMemo(
  //   () =>
  //     keyframes({
  //       from: {
  //         boxShadow: `0px 0px 0px 0px ${TAG_COLORS[tag.data.color]}`,
  //       },
  //       to: {
  //         boxShadow: "0px 0px 0px 16px #5c61ff00",
  //       },
  //     }),
  //   [tag]
  // );

  return (
    <>
      <Box
        id={tag.id}
        ref={ref}
        sx={{
          ...classes.tagWrapper,
          background: TAG_COLORS[tag.data.color],
          // width: baseTagSize,
          // height: baseTagSize,
          // animation: `${animation} 2s 0.4s infinite`,
          display: "none",

          // "&::before": borderAnimation(TAG_COLORS[tag.data.color], 1.6),
        }}
        onClick={(e) => {
          handleClick(e);
        }}
      >
        <Box
          sx={{
            width: "50%",
          }}
        >
          <TagIcon icon={tag.data.icon} color="black" size={42} />
        </Box>
        {/* <Box
          sx={{
            position: "absolute",
            fontSize: "12px",
            background: "#000000",
            padding: "6px",
            whiteSpace: "nowrap",
            borderRadius: "8px",
            bottom: "-48px",
            transformOrigin: "top",
          }}
        >
          {tag.data.name}
        </Box> */}
      </Box>

      <Popover
        id={tag.id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={close}
        container={wrapperRef.current}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <TagPopup close={close} tag={tag} />
      </Popover>
    </>
  );
});

export default VideoTag;
